<template>
  <div @click="stopPropagation" class="data-picker">
    <div :class="headerClass">
      <span>{{title}}:</span>
      <div class="filter style-class">
        <span class="filter-label">{{currentSelection}}</span>
          <div class="dropdown-btn" @click="toggleDropDown">
            <image-svg :imageName="'arrow-expand'"/>
          </div>
        </div>
      </div>
      <div v-if="dropDownActive" style="display:block" :class="bodyClass">
        <ul>
          <li v-for="(item, index) in items" :key="index"
          :class="isSelected(item.index)" @click="onChange(item.index)">{{item.title}}</li>
        </ul>
      </div>
  </div>
</template>

<script>
import ImageSVG from '@/components/common/ImageSVG.vue'
export default {
  components: {
    'image-svg': ImageSVG
  },
  props: {
    title: String,
    headerClass: {
      type: String
    },
    bodyClass: {
      type: String
    },
    items: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data () {
    return {
      selectedItem: 3,
      dropDownActive: false
    }
  },
  watch: {
    selectedItem: function (val, old) {
      this.$emit('input', val + '')
    }
  },
  methods: {
    stopPropagation () {
      if (!this.dropDownActive) {
        event.stopPropagation()
        return
      }
      setTimeout(() => {
        this.toggleDropDown()
      }, 100)
    },
    onChange (value) {
      this.selectedItem = value
      this.toggleDropDown()
    },
    toggleDropDown () {
      this.dropDownActive = !this.dropDownActive
    },
    hidePicker () {
      this.dropDownActive = false
    },
    isSelected (item) {
      return this.selectedItem === item ? 'selected' : ''
    }
  },
  computed: {
    currentSelection: function () {
      switch (this.selectedItem) {
        case 0:
          return this.$t('losing')
        case 1:
          return this.$t('winning')
        case 3:
          return this.$t('all')
        default:
          return '100'
    // code block
      }
    }
  }
}
</script>
